// Lib
import React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const LABEL_MARGIN_BOTTOM = 0.5;

const InfoCardField = ({
  label,
  value,
  isMobileMode,
  variant,
  labelClassName,
  valueClassName,
}) => (
  <Box
    display="flex"
    flexDirection={isMobileMode ? 'row' : 'column'}
    gap={isMobileMode ? '0.5rem' : 0}>
    <Typography
      variant={variant}
      mb={variant ? LABEL_MARGIN_BOTTOM : undefined}
      className={labelClassName}>
      {label}
      {isMobileMode && ':'}
    </Typography>
    {value && (
      <Typography variant={variant} className={valueClassName}>
        {value}
      </Typography>
    )}
  </Box>
);

export default InfoCardField;
